import React, { useCallback } from 'react'
import { makeStyles, Icon, Switch } from '@material-ui/core'
import { gray, purple } from '../../utils/colors'

const StyledSwitch = ({ checked = false, onChecked, disabled = false }) => {
	const classes = useStyles()

	const handleChange = useCallback(
		(e) => {
			if (onChecked) {
				onChecked(e)
			}
		},
		[onChecked]
	)

	return (
		<Switch
			disabled={disabled}
			checked={checked}
			onChange={handleChange}
			icon={
				<div key="unchecked" className={classes.thumb}>
					<Icon className="far fa-times" />
				</div>
			}
			checkedIcon={
				<div key="checked" className={classes.thumb}>
					<Icon className="far fa-check" />
				</div>
			}
			classes={{
				root: classes.switchRoot,
				thumb: classes.thumb,
				track: classes.track
			}}
		/>
	)
}

const useStyles = makeStyles((theme) => ({
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0,
		'& .MuiSwitch-switchBase': {
			padding: 0,
			margin: 2
		},
		'& .MuiSwitch-switchBase.Mui-checked': {
			'& + .MuiSwitch-track': {
				backgroundColor: purple[500],
				opacity: 1
			},
			'& div[class*="thumb"]': {
				backgroundColor: gray[100],
				'& .far, & svg': {
					color: purple[500]
				}
			}
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: gray[100],
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far, & svg': {
			color: gray[700],
			fontSize: '0.625rem',
			lineHeight: 1,
			width: '1em',
			height: '1em'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: gray[600],
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	}
}))

export default StyledSwitch
